import useMedia from 'common/hooks/useMedia';
import Icon from 'engage/components/Icon/Icon';
import { useMessageContext } from 'engage/context/MessageContext';
import { useUserContext } from 'engage/context/UserContext';
import React, { useMemo } from 'react';

export const useSidebarLinks = () => {
    const { user, userLoading, isContentScheduleEnabled, isApprovalFlowEnabled, isReviewerUser, logFirebaseEvent, newWebAppDesign } = useUserContext();
    const { unreadMessagesCount, showNotificationDetail, setShowNotificationDetail } = useMessageContext();

    const isMobile = useMedia({ maxWidth: 900 });

    const availableLinks = useMemo(() => {
        if (!user || userLoading) {
            return [{
                name: 'About Vormats',
                key: 'about_vormats',
                icon: <Icon src="about_vormats" verticalAlign="middle" style={{ fontSize: '24px' }} />,
                ariaLabel: "Login",
                action: () => window.open('https://vormats.com', '_blank', 'noopener,noreferrer'),
            }];
        }

        const parsedUnreadCount = Number(unreadMessagesCount);
        const normalizedUnreadCount = Number.isFinite(parsedUnreadCount) ? Math.max(parsedUnreadCount, 0) : 0;
        const hasUnreadMessages = normalizedUnreadCount > 0;
        const unreadBadge = hasUnreadMessages ? <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            minWidth: '20px',
            width: 'auto',
            height: '20px',
            background: '#4FDFBD',
            border: '1px solid #F8F6FB',
            borderRadius: '25px',
            marginLeft: '8px',
            ...(normalizedUnreadCount > 99 ? { minWidth: '30px' } : {}),
        }}>
            <p style={{
                fontFamily: 'Nunito Sans',
                fontStyle: 'normal',
                fontWeight: '700',
                fontSize: '12px',
                lineHeight: '100%',
                color: '#FFFFFF',
                margin: 0
            }}>{normalizedUnreadCount > 99 ? '99+' : normalizedUnreadCount}</p>
        </div> : null;

        return [{
            name: 'sidebar.home',
            key: 'home',
            icon: <Icon src="home" verticalAlign="middle" style={{ fontSize: '24px', marginTop: '-3px' }} />,
            ariaLabel: "Home",
            path: "/eg/home",
        },
        ...(newWebAppDesign ? [] : [{
            name: 'sidebar.videos',
            key: 'videos',
            icon: <Icon src="rectangle_260" verticalAlign="middle" style={{ fontSize: '24px' }} />,
            ariaLabel: "Videos",
            path: "/eg/dashboard",
        }]),
        {
            name: 'sidebar.folders',
            key: 'folders',
            icon: <Icon src="folders" verticalAlign="middle" style={{ fontSize: '24px' }} />,
            ariaLabel: "Folders",
                path: newWebAppDesign ? "/eg/folders" : { pathname: "/eg/dashboard", state: { folders: true } },
        },
            ...(newWebAppDesign ? [] : [{
                name: 'sidebar.team_folders',
                key: 'team_folders',
                icon: <Icon src="teams" verticalAlign="middle" style={{ fontSize: '24px' }} />,
                ariaLabel: "Teams",
                path: { pathname: "/eg/dashboard", state: { team: true } },
            }]),
        {
            hide: !isContentScheduleEnabled || isMobile,
            key: 'schedule',
            name: {
                literal: 'sidebar.schedule',
            },
            icon: <Icon src="schedule" verticalAlign="middle" style={{ fontSize: '24px' }} />,
            ariaLabel: "Schedule",
            path: "/eg/schedule",
        },
            ...(newWebAppDesign ? [] : [{
            key: 'archive',
            name: 'sidebar.archive',
            icon: <Icon src="archiveSidebar" verticalAlign="middle" style={{ fontSize: '24px' }} />,
            ariaLabel: "Archive",
            path: "/eg/archive",
            }]),
        {
            key: 'notifications',
            name: {
                literal: 'sidebar.notifications', addition: unreadBadge
            },
            icon: <Icon src="notification" verticalAlign="middle" style={{ fontSize: '24px' }} />,
            ariaLabel: "Notification",
            path: "/eg/notifications",
            action: () =>
                showNotificationDetail &&
                setShowNotificationDetail(false) &&
                logFirebaseEvent('sb_release_cl', { user_id: user.username }),
        },
        {
            key: 'messages',
            hide: !isApprovalFlowEnabled && !isReviewerUser,
            name: 'sidebar.review',
            icon: <Icon src="review" verticalAlign="middle" style={{ fontSize: '24px' }} />,
            ariaLabel: "Review",
            path: "/eg/review",
        }]
    }, [isMobile, userLoading, user, isApprovalFlowEnabled, isReviewerUser, unreadMessagesCount, isContentScheduleEnabled])

    return {
        availableLinks,
    }
}

